import { Component } from 'vue-property-decorator'
import { TrainingPlanBuilder } from '@src/routes/content/training-plan-builder'
import { CreateElement } from 'vue'
import { Builder } from '@src/routes/content/components/builder'
import { TrainingPlanName } from '@src/routes/content/components/training-plan-builder/training-plan-name'
import { AssignPlanToMember } from '@src/routes/content/components/training-plan-builder/assign-plan-member'
import { Icon } from '@src/elements/icon/icon'
import { WorkoutSelector } from '@src/routes/content/components/training-plan-builder/workout-selector'
import { DaysBuilder } from '@src/routes/content/components/training-plan-builder/days-builder'
import { TrainingPlanComposition } from '@src/routes/content/components/training-plan-builder/training-plan-composition'
import { ConfirmModal } from '@src/elements/modal/confirm-modal'
import { NotificationTypes } from '@src/util/constants'
import { SaveMemberTrainingPlan } from '@src/routes/member-platform/components/active-trainings-workouts/save-plan'
import { LoadingScreen } from '@src/components/loading-screen/loading-screen/loading-screen'

@Component
export class MemberTrainingPlanBuilder extends TrainingPlanBuilder {

  setDocumentTitle () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('PAGE.CONTENT.TRAINING_PLAN.TAB_NAME')}`
  }

  render (h: CreateElement) {
    return this.loading ? <LoadingScreen/> : <Builder cssClass='training-plan-builder'>
      <TrainingPlanName slot={'topLeft'} />

      <AssignPlanToMember slot={'topMiddle'} />

      <SaveMemberTrainingPlan slot={'topRight'} />

      <div onClick={this.closeBuilderAttempt} slot='close'><Icon name='util/close-circled' /></div>

      <WorkoutSelector slot={'selector'} />

      <DaysBuilder slot={'builder'} />

      <TrainingPlanComposition slot={'composition'} />

      <ConfirmModal show={this.showConfirmPopup}
                    closeCallback={this.closeBuilder}
                    message={this.$t('PAGE.CONTENT.CLOSE_CONFIRMATION')}
                    type={NotificationTypes.CONFIRM} />
    </Builder>
  }

  closeBuilder (close?: boolean) {
    this.showConfirmPopup = false
    if (close === true) {
      this.$router.go(-1)
    }
  }
}
